import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Input, InputGroup, FormGroup, Form, Row, Col, Table } from 'reactstrap';
import { Translate, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IMedia } from 'app/shared/model/media.model';
import { searchEntities, getEntities } from './media.reducer';

export const Media = (props: RouteComponentProps<{ url: string }>) => {
  const dispatch = useAppDispatch();

  const [search, setSearch] = useState('');

  const mediaList = useAppSelector(state => state.media.entities);
  const loading = useAppSelector(state => state.media.loading);

  useEffect(() => {
    dispatch(getEntities({}));
  }, []);

  const startSearching = e => {
    if (search) {
      dispatch(searchEntities({ query: search }));
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const handleSyncList = () => {
    dispatch(getEntities({}));
  };

  const { match } = props;

  return (
    <div>
      <h2 id="media-heading" data-cy="MediaHeading">
        <Translate contentKey="xtdtApp.media.home.title">Media</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="xtdtApp.media.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/media/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="xtdtApp.media.home.createLabel">Create new Media</Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('xtdtApp.media.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {mediaList && mediaList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="xtdtApp.media.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.media.tieuDe">Tieu De</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.media.loaiMedia">Loai Media</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.media.link">Link</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.media.hienThiTrangChu">Hien Thi Trang Chu</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.media.thuTu">Thu Tu</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.media.fileEntry">File Entry</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.media.gallery">Gallery</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.media.baiViet">Bai Viet</Translate>
                </th>
                <th>
                  <Translate contentKey="xtdtApp.media.duAn">Du An</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {mediaList.map((media, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/media/${media.id}`} color="link" size="sm">
                      {media.id}
                    </Button>
                  </td>
                  <td>{media.tieuDe}</td>
                  <td>
                    <Translate contentKey={`xtdtApp.LoaiMediaEnum.${media.loaiMedia}`} />
                  </td>
                  <td>{media.link}</td>
                  <td>{media.hienThiTrangChu ? 'true' : 'false'}</td>
                  <td>{media.thuTu}</td>
                  <td>{media.fileEntry ? <Link to={`/file-entry/${media.fileEntry.id}`}>{media.fileEntry.id}</Link> : ''}</td>
                  <td>{media.gallery ? <Link to={`/gallery/${media.gallery.id}`}>{media.gallery.id}</Link> : ''}</td>
                  <td>
                    {media.baiViets
                      ? media.baiViets.map((val, j) => (
                          <span key={j}>
                            <Link to={`/bai-viet/${val.id}`}>{val.id}</Link>
                            {j === media.baiViets.length - 1 ? '' : ', '}
                          </span>
                        ))
                      : null}
                  </td>
                  <td>
                    {media.duAns
                      ? media.duAns.map((val, j) => (
                          <span key={j}>
                            <Link to={`/du-an/${val.id}`}>{val.id}</Link>
                            {j === media.duAns.length - 1 ? '' : ', '}
                          </span>
                        ))
                      : null}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/media/${media.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`/media/${media.id}/edit`} color="primary" size="sm" data-cy="entityEditButton">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`/media/${media.id}/delete`} color="danger" size="sm" data-cy="entityDeleteButton">
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="xtdtApp.media.home.notFound">No Media found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default Media;
